import { BookingDepositType } from 'shared/types';

import UTMType from '../hooks/useUTM';

import I18nObject from './I18nObject';
import { LanguagesEnum } from './languages';
import { Media } from './main';

export type CustomerType = {
	email: string;
	phone: string;
	name: string;
};

export enum BookingStatus {
	DRAFT = 'DRAFT',
	PAYING = 'PAYING',
	COMPLETED = 'COMPLETED',
	CREATED = 'CREATED',
	CONFIRMED = 'CONFIRMED',
	CANCELLED = 'CANCELLED',
	EXPIRED = 'EXPIRED',
	EXTERNAL_CANCELLING = 'EXTERNAL_CANCELLING',
}

export enum BookingStatusES {
	ACCEPTING = 'ACCEPTING',
	CONFIRMED = 'CONFIRMED',
	CANCELLED = 'CANCELLED',
}

export enum PaymentBookingStatus {
	BACK = 'back',
	PROCESSING = 'processing',
	SUCCESS = 'success',
	ERROR = 'error',
}

export const BookingStatusESMap = {
	[BookingStatusES.ACCEPTING]: BookingStatus.CREATED,
	[BookingStatusES.CONFIRMED]: BookingStatus.CONFIRMED,
	[BookingStatusES.CANCELLED]: BookingStatus.CANCELLED,
};

export const BookingStatusTranslation = {
	[BookingStatus.CREATED]: 'booking_request_sent',
	[BookingStatus.CONFIRMED]: 'booking_request_confirmed',
	[BookingStatus.CANCELLED]: 'booking_cancelled',
	[BookingStatus.EXPIRED]: 'booking_request_expired',
};

export type BookingSettings = {
	allowRequestOutsideWorkingHours: boolean;
	enabled: boolean;
	maxDaysBefore: number;
	maxPeopleCount?: number;
	media: Media;
	name: string;
	url: string;
	customerMessage: string | null;
	minIntervalBefore: number;
	minIntervalBeforeClosed: number;
	showWorkingHoursMessage: boolean;
	visitDuration: number;
	maxVisitDuration: number;
	minVisitDuration: number;
	requiredEmailBooking: boolean;
	localTime: string;
	locationSelector: boolean;
	legalInfo?: {
		name: string;
	};
	deposit?: BookingDepositType;
	workingHours?: {
		exceptions?: BookingDateException[];
	};
	guestMarkers?: I18nObject[] | null;
};

export type BookingDateException = {
	date: string;
	from: string;
	till: string;
};

export type BookingPreferredArea = {
	_id: string;
	name: string;
};

export type BookingType = {
	comment: string;
	customer: CustomerType;
	dateTime: string;
	guid: string;
	num: number;
	personCount: number;
	redirectUrl?: string;
	status: BookingStatus;
	token: string;
	cancelReason?: string;
	visitDuration?: number;
	cancellable?: boolean;
	deposit?: {
		amount: number;
		currency: string;
		paid: boolean;
		paidAt: string;
		paymentId: string;
	};
};

export type UTMType = {
	source?: string;
};

export type MakeBookingType = {
	dateTime: string;
	email: string | null;
	langCode: LanguagesEnum;
	name: string;
	personCount: number;
	phone: string;
	comment?: string;
	visitDuration?: number;
	preferArea?: string;
	allowMarketing?: boolean;
	customerVAT?: string;
	marketing?: {
		utm?: UTMType;
	};
	guestMarkers?: I18nObject[] | null;
};

export type BlockedTime = {
	date: string;
	comment: string | null;
	allDay: boolean;
	intervals: {
		from: string;
		till: string;
	}[];
	interval: {
		from: string;
		till: string;
	};
};

export type BlockedTimeResponse = {
	from: string;
	till: string;
	blocks: BlockedTime[];
};

export type PayBookingResponse = {
	paid: boolean;
	status: PaymentBookingStatus;
	bookingGUID: string;
};
